// extracted by mini-css-extract-plugin
export default {"cell":"PromotionBarSlidesTable_cell__DTbEE","actionHeader":"PromotionBarSlidesTable_actionHeader__w8zpq","contentCell":"PromotionBarSlidesTable_contentCell__Igi+n"};